import axios from "axios";

const instance = axios.create({
    headers: 'Content-Type: application/json',
    responseType: "json"
});

export default instance;